/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespShippingReturns_shipmentQuote$ref = any;
type PdpRespSidebarBlurbs_shipmentQuote$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainer_shipmentQuote$ref: FragmentReference;
export type PdpRespContainer_shipmentQuote = {|
  +$fragmentRefs: PdpRespSidebarBlurbs_shipmentQuote$ref & PdpRespShippingReturns_shipmentQuote$ref,
  +$refType: PdpRespContainer_shipmentQuote$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainer_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_shipmentQuote",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_shipmentQuote",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'efb9d699ed292459b86b63bb220d8246';
module.exports = node;
